(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["text-2"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ophir-collapsible-text')) {
    class OphirCollapsibleText extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector('[data-collapsible-content]');
        this.toggle = this.querySelector('[data-collapsible-toggle]');
        this.collapsedLabel = this.querySelector('[data-collapsed-label]');
        this.expandedLabel = this.querySelector('[data-expanded-label]');

        if (!this.content || !this.toggle) return;

        this.handleClick = () => {
          this.setExpanded(this.toggle.getAttribute('aria-expanded') !== 'true');
        };
        this.handleResize = () => {
          window.cancelAnimationFrame(this.resizeFrame);
          this.resizeFrame = window.requestAnimationFrame(() => this.updateOverflow());
        };

        this.toggle.addEventListener('click', this.handleClick);
        window.addEventListener('resize', this.handleResize, { passive: true });

        window.requestAnimationFrame(() => this.updateOverflow());
        document.fonts?.ready.then(() => this.updateOverflow());
      }

      disconnectedCallback() {
        this.toggle?.removeEventListener('click', this.handleClick);
        window.removeEventListener('resize', this.handleResize);
        window.cancelAnimationFrame(this.resizeFrame);
      }

      setExpanded(expanded) {
        this.toggle.setAttribute('aria-expanded', String(expanded));
        this.content.classList.toggle('is-collapsed', !expanded);
        this.collapsedLabel.hidden = expanded;
        this.expandedLabel.hidden = !expanded;
      }

      updateOverflow() {
        const wasExpanded = this.toggle.getAttribute('aria-expanded') === 'true';

        // Mede primeiro o conteúdo sem limite. Em alguns navegadores,
        // scrollHeight pode refletir a altura já cortada por max-height.
        this.content.classList.remove('is-collapsed');
        const naturalHeight = this.content.scrollHeight;

        this.content.classList.add('is-collapsed');
        const collapsedHeight = this.content.clientHeight;
        const hasOverflow = naturalHeight > collapsedHeight + 1;

        this.toggle.hidden = !hasOverflow;

        if (!hasOverflow) {
          this.setExpanded(false);
          this.content.classList.remove('is-collapsed');
          return;
        }

        this.setExpanded(wasExpanded);
      }
    }

    customElements.define('ophir-collapsible-text', OphirCollapsibleText);
  }
  } catch(e) { console.error(e); }
})();

})();
